<section class="common-padd-lt-rt profile-wrap">
  <div class="container-fluid">
    <div class="row">
      <div class="col-lg-12">
        <!--

                <div class="profile-big-ttl"
                    style="background-image: url(../assets/images/star-bg.png); background-repeat: no-repeat; background-position: right center;  background-size: cover;">
                    <h1>User Profile</h1>
                </div>-->
        <div class="small-banner">
          <div class="img">
            <img
              src="../../../assets/images/User-profile.jpg"
              alt="user-profile"
            />
          </div>
        </div>

        <div
          class="import-cv-top"
          *ngIf="
            !this.profileRecords.isResumeParsed &&
            !this.isComingFromCvReviewWithoutCv
          "
        >
          <div class="row align-items-center">
            <div class="col-lg-7">
              <div class="import-cv-top-desc">
                <h1>Import your CV</h1>
                <p>
                  Already have a CV? Upload the file (doc, docx, or pdf) and we
                  will automatically convert it to an online profile that you
                  can edit, share as a link, and use to apply for positions.
                  Recruiters can also search for you based on your profile to
                  see if you are a match for open jobs.
                </p>
                <div class="upload-cv-btn-wrap">
                  <a
                    _ngcontent-cwt-c376=""
                    href="javascript:void(0);"
                    class="btn-green"
                  >
                    Upload CV</a
                  >
                  <input
                    _ngcontent-cwt-c376=""
                    type="file"
                    title="Click to upload your CV"
                    (change)="onSelectFile($event)"
                    accept="application/pdf,application/docx,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                  />
                </div>
              </div>
            </div>
            <div class="col-lg-5">
              <figure>
                <div class="img">
                  <img
                    src="../assets/images/image75.png"
                    alt="banner"
                  />
                </div>
              </figure>
            </div>
          </div>
        </div>

        <div class="prfl-userbox">
          <div class="edt-hdng">
            <h3>Profile</h3>
            <a
              href="javascript:void(0);"
              (click)="profile()"
              class="edit-link"
              ><i class="fas fa-pen"></i> EDIT PROFILE</a
            >
          </div>
          <div class="profile-user-topinfo">
            <div class="user-img">
              <img
                src="{{
                  profileRecords?.profileImage
                    ? profileRecords?.profileImage
                    : '../assets/images/defaultuser.png'
                }}"
                alt=""
              />
            </div>
            <div class="pro-top-hd sm-padd-btm">
              <a
                href="javascript:void(0);"
                class="btn-green"
                (click)="exportAsPDF()"
                ><i class="fas fa-download"></i> Download as CV</a
              >
              &nbsp;
              <a
                href="javascript:void(0);"
                class="btn-green wh-bg"
                (click)="shareJob()"
                ><i class="fas fa-share-alt"></i> Share profile link</a
              >
            </div>
            <h5>
              {{ profileRecords?.firstName }} {{ profileRecords?.middleName }}
              {{ profileRecords?.lastName }}
            </h5>
            <h5>{{ profileRecords?.contactNumber }}</h5>
            <p>About</p>
            <div class="info-list">
              <ul>
                <li>
                  <div [innerHTML]="profileRecords.about"></div>
                  <!-- <p [innerHTML]="profileRecords.about"></p> -->
                </li>
                <li *ngIf="profileRecords?.title != ''">
                  Title - {{ profileRecords?.title }}
                </li>
                <li *ngIf="profileRecords?.website != ''">
                  Website - {{ profileRecords?.website }}
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div class="prfl-userbox">
          <div class="edt-hdng">
            <h4>Education</h4>
            <a
              href="javascript:void(0);"
              (click)="education('NEW')"
              class="btn btn-green"
              >Add Education</a
            >
          </div>
          <div class="profile-info-list">
            <ul *ngFor="let row of educationAllRecords; let i = index">
              <li>
                <div class="lt-info">
                  <p>{{ row.universityName }}</p>
                  <p>
                    <small>{{ row.courseName }}</small>
                  </p>
                </div>
                <a
                  href="javascript:void(0);"
                  (click)="education(row)"
                  class="edit-link"
                  ><i class="fas fa-pen"></i> EDIT</a
                >
              </li>
            </ul>
          </div>
        </div>

        <div class="prfl-userbox">
          <div class="edt-hdng">
            <h4>Experience</h4>
            <a
              href="javascript:void(0);"
              (click)="experiance('NEW')"
              class="btn btn-green"
              >Add Experience</a
            >
          </div>
          <div class="profile-info-list">
            <ul *ngFor="let row of experianceAllRecords; let i = index">
              <li>
                <div class="lt-info">
                  <p>{{ row.company }}</p>
                  <p>
                    <small
                      >{{ row.title }}<br />{{ row.startDate | date }} –
                      {{
                        row.endDate == null ? 'Present ' : (row.endDate | date)
                      }}
                      • {{ calculateDuration(row.startDate, row.endDate) }}
                    </small>
                  </p>
                </div>
                <a
                  href="javascript:void(0);"
                  (click)="experiance(row)"
                  class="edit-link"
                  ><i class="fas fa-pen"></i> EDIT</a
                >
              </li>
            </ul>
          </div>
        </div>

        <div class="prfl-userbox">
          <div class="edt-hdng">
            <h4>Licenses & certifications</h4>
            <a
              href="javascript:void(0);"
              (click)="certifiate('NEW')"
              class="btn btn-green"
              >Add Licenses & Certifications</a
            >
          </div>
          <div class="profile-info-list">
            <ul *ngFor="let row of licenseAllRecords; let i = index">
              <li>
                <div class="lt-info">
                  <p>{{ row.name }}</p>
                  <p>
                    <small>{{ row.issuingOrganization }}<br /> </small>
                    <small *ngIf="row.issueDate">
                      Issued -
                      {{ row.issueDate | date }} •
                      {{
                        row.endDate == null ? 'Present' : (row.endDate | date)
                      }}
                    </small>
                    <br />
                    <small *ngIf="row.credentialId"
                      >Credential ID {{ row.credentialId }}
                    </small>
                  </p>
                </div>
                <a
                  href="javascript:void(0);"
                  (click)="certifiate(row)"
                  class="edit-link"
                  ><i class="fas fa-pen"></i> EDIT</a
                >
              </li>
            </ul>
          </div>
        </div>

        <div class="prfl-userbox">
          <div class="edt-hdng">
            <h4>Skills</h4>
            <a
              href="javascript:void(0);"
              (click)="skill()"
              class="btn btn-green"
              >Add Skills</a
            >
          </div>
          <div class="profile-skill-list">
            <figcaption>
              <mat-form-field
                class="example-chip-list custom-chip-set"
                [ngClass]="
                  this.skillAllRecords.length > 5
                    ? 'mobile-view-skill-section'
                    : ''
                "
                style="border: none"
              >
                <mat-chip-list
                  #chipList
                  aria-label="Fruit selection"
                  style="border: none"
                >
                  <mat-chip
                    style="border: none"
                    *ngFor="let fruit of this.skillAllRecords"
                  >
                    {{ fruit }}
                  </mat-chip>
                </mat-chip-list>
              </mat-form-field>
            </figcaption>
          </div>
        </div>

        <div
          *ngIf="isComingFromCvReviewWithoutCv"
          class="preview-btn-wrapper"
        >
          <button
            class="btn btn-green"
            type="button"
            (click)="continueToPreview()"
          >
            Continue to Preview
          </button>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- <div class="custom-page-height">



                <div class="card">
                    <h2>
                        Skills <span><a href="javascript:void(0);" class="btn-green editicon" (click)="skill()"><i
                            class="fas fa-pen"></i> EDIT
                                SKILLS</a></span>
                    </h2>
                    <div class="card-mid-description">
                        <div class="row">
                            <div class="col-lg-12">

                                <figcaption>
                                    <mat-form-field class="example-chip-list custom-chip-set" [ngClass]="this.skillAllRecords.length > 5 ? 'mobile-view-skill-section' : ''"style="border: none;">

                                        <mat-chip-list #chipList aria-label="Fruit selection" style="border: none;">
                                            <mat-chip style="border: none;" *ngFor="let fruit of this.skillAllRecords">
                                                {{fruit}}

                                            </mat-chip>

                                        </mat-chip-list>

                                    </mat-form-field>
                                </figcaption>
                            </div>
                        </div>
                    </div>


                </div>
            </div>
        </div>
    </div>
</div> -->
<!-- [ngClass]="{'subhojitDisplay' : isDisplay == true }" -->
<!-- <a [href]="profileRecords?.profileImage" class="btn cancel-button" target="_self" download>Download</a> -->

<div
  *ngIf="isDisplay"
  id="htmlData"
  class="cv-page cv12"
  style="width: 100%; display: block; background-color: #ffffff; padding: 20px;"
>
  <div class="cv-frame">
    <!-- HEADER -->
    <header class="cv-header">
      <div class="name-block">
        <h1 class="name">{{ profileRecords?.firstName }} {{ profileRecords?.lastName }}</h1>
        <p
          class="designation"
          *ngIf="profileRecords?.title"
        >
          {{ profileRecords?.title }}
        </p>
      </div>

      <div class="contact-block">
        <p *ngIf="profileRecords?.contactNumber">
          📞 {{ profileRecords?.contactNumber }}
        </p>
        <p *ngIf="profileRecords?.email">
          ✉ {{ profileRecords?.email }}
        </p>
        <p *ngIf="profileRecords?.userLocation || profileRecords?.city">
          📍 {{ profileRecords?.userLocation || profileRecords?.city }}
        </p>
        <p *ngIf="profileRecords?.linkedInId">
          in {{ profileRecords?.linkedInId }}
        </p>
      </div>
    </header>

    <!-- SUMMARY -->
    <div class="cv-summary">
      <section
        class="summary"
        *ngIf="profileRecords?.about"
      >
        <h3 class="section-title">SUMMARY</h3>
        <p [innerHTML]="profileRecords?.about"></p>
      </section>
    </div>

    <div class="cv-body">
      <!-- LEFT COLUMN -->
      <aside class="left-col">
        <section
          class="education"
          *ngIf="educationAllRecords?.length"
        >
          <h3 class="section-title blue">EDUCATION</h3>
          <div
            *ngFor="let edu of educationAllRecords"
            class="edu"
          >
            <div class="degree">{{ edu.courseName }}</div>
            <div class="uni">{{ edu.universityName }}</div>
            <div class="timeline">{{ edu.endYear }}</div>
          </div>
        </section>

        <section
          class="skills"
          *ngIf="skillAllRecords?.length"
        >
          <h3 class="section-title blue">SKILLS</h3>
          <ul>
            <li *ngFor="let skill of skillAllRecords">{{ skill }}</li>
          </ul>
        </section>

        <section
          class="awards"
          *ngIf="licenseAllRecords?.length"
        >
          <h3 class="section-title blue">CERTIFICATIONS</h3>
          <ul>
            <li *ngFor="let cer of licenseAllRecords">
              <span>{{ cer.name }}</span>
              <span *ngIf="cer.issuingOrganization"> ({{ cer.issuingOrganization }})</span>
            </li>
          </ul>
        </section>
      </aside>

      <!-- RIGHT COLUMN -->
      <main class="right-col">
        <section
          class="experience"
          *ngIf="experianceAllRecords?.length"
        >
          <h3 class="section-title">EXPERIENCE</h3>
          <div
            class="exp-item"
            *ngFor="let exp of experianceAllRecords"
          >
            <h4 class="job-title">{{ exp.title }} <ng-container *ngIf="exp.company">at {{ exp.company }}</ng-container></h4>
            <p class="dates-location">
              {{ exp.startDate | date }} - {{ exp.endDate ? (exp.endDate | date) : 'Present' }}
            </p>
            <ul class="description-points">
              <li style="white-space: pre-wrap">{{ exp.description }}</li>
            </ul>
          </div>
        </section>
      </main>
    </div>
  </div>
</div>
